export default "__VITE_ASSET__BKZbw6m3__"